import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../../utils/test-utils/unidriver';

export const actionButtonDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),

    /** Returns button label */
    getLabel: () => base.text(),
  };
};

export type ActionButtonDriver = ReturnType<typeof actionButtonDriverFactory>;
